import bootstrap from '@ezugi/bootstrap';
import config from './config';

bootstrap(config);
